import { getOffset } from 'utils';

const links = document.querySelectorAll('[data-activity-range-link]');
const anchor = document.querySelector('[data-activity-range-anchor]');

if (links.length && anchor !== null) {
  Array.forEach(links, (link) => {
    link.addEventListener('click', handleLinkClick);
  });
}

function handleLinkClick(e) {
  e.preventDefault();

  const top = getOffset(anchor).top - 54;
  window.scrollTo({
    top,
    behavior: 'smooth',
  });
}
